function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState, useEffect, useRef } from 'react';
import EmailEditor from 'react-email-editor';
import CommonModal from './CommonModal';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function Example() {
  var emailEditorRef = useRef(null);
  var axios = require('axios')["default"];
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    puposalId = _useState2[0],
    setPuposalId = _useState2[1];
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    documentId = _useState4[0],
    setdocumentId = _useState4[1];
  var _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    message = _useState6[0],
    setMessage = _useState6[1];
  var onLoad = function onLoad() {
    axios.get('/proposal/view_design/' + puposalId).then(function (response) {
      if (emailEditorRef.current) {
        emailEditorRef.current.editor.loadDesign(response.data);
      }
    })["catch"](function (error) {
      console.log(error);
    });
  };
  var saveDesign = function saveDesign() {
    if (!emailEditorRef.current) {
      return;
    }
    emailEditorRef.current.editor.exportHtml(function (data) {
      var design = data.design,
        html = data.html;
      emailEditorRef.current.editor.saveDesign(function (design) {
        axios.post('/proposal/save_design', {
          content: design,
          html: html,
          puposalId: puposalId
        }).then(function () {
          setMessage("Proposal saved successfully");
          setTimeout(function () {
            setMessage("");
          }, 1500);
        })["catch"](function (error) {
          console.log(error);
        });
      });
    });
  };
  useEffect(function () {
    var _document$getElementB;
    var id = (_document$getElementB = document.getElementById('proposalId')) === null || _document$getElementB === void 0 ? void 0 : _document$getElementB.value;
    if (id) {
      setPuposalId(id);
    }
  }, []);
  useEffect(function () {
    window.saveDesign = saveDesign;
    return function () {
      delete window.saveDesign;
    };
  }, [puposalId, emailEditorRef]);
  useEffect(function () {
    var _document$getElementB2;
    var documentid = (_document$getElementB2 = document.getElementById('documentId')) === null || _document$getElementB2 === void 0 ? void 0 : _document$getElementB2.value;
    if (documentid) {
      setdocumentId(documentid);
    }
  }, []);
  useEffect(function () {
    if (puposalId > 0) {
      onLoad();
    }
  }, [puposalId]);
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    modalIsOpen = _useState8[0],
    setIsOpen = _useState8[1];
  function openModal() {
    setIsOpen(true);
  }
  function closeModal() {
    setIsOpen(false);
  }
  function success() {
    setIsOpen(false);
    window.location.href = "/proposal/delete/" + documentId;
  }
  return /*#__PURE__*/_jsxs("div", {
    style: {
      display: "flex",
      flexDirection: "column",
      width: "100%"
    },
    children: [/*#__PURE__*/_jsx(CommonModal, {
      isOpen: modalIsOpen,
      headerTitle: "Confirm",
      onClose: closeModal,
      onSuccess: success
    }), message && /*#__PURE__*/_jsx("div", {
      className: "result",
      style: {
        padding: '12px 24px',
        color: '#15803d',
        background: '#dcfce7',
        borderBottom: '1px solid #bbf7d0',
        fontWeight: '600',
        fontSize: '14px',
        position: 'fixed',
        top: '80px',
        right: '20px',
        zIndex: 9999,
        borderRadius: '6px',
        boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)'
      },
      children: message
    }), /*#__PURE__*/_jsx(EmailEditor, {
      minHeight: "calc(100vh - 145px)",
      tools: {
        menu: {
          enabled: false
        }
      },
      ref: emailEditorRef,
      onLoad: onLoad
    })]
  });
}
export default Example;